export default __webpack_public_path__ + "static/media/logo.132fd515.png";